import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
            <div className="footer-brand">
                <img
                    src="/logo.png"
                    alt="Magyne Logo"
                    className="footer-logo"
                />

                <p>
                    Empowering businesses with modern cloud software that is secure,
                    scalable and simple to use.
                </p>

                <div className="footer-version">
                    Version 1.0.0
                </div>
            </div>
        <div className="footer-links">

          <div>
            <h4>Product</h4>

            <Link to="/">Home</Link>
            <Link to="/solutions">Solutions</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/roadmap">Roadmap</Link>
          </div>

          <div>
            <h4>Company</h4>

            <Link to="/about">About</Link>
            {/* <Link to="/careers">Careers</Link>
            <Link to="/blog">Blog</Link> */}
            <Link to="/contact">Contact</Link>
          </div>

          {/* <div>
            <h4>Resources</h4>

            <Link to="/documentation">Documentation</Link>
            <Link to="/developers">Developers</Link>
            <Link to="/system-status">System Status</Link>
            <Link to="/changelog">Release Notes</Link>
          </div> */}

          <div>
            <h4>Legal</h4>
            <Link to="/sla">Service Level Agreement</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/cookies">Cookie Policy</Link>
            <Link to="/security">Security & Compliance</Link>
            <Link to="/acceptable-use">Acceptable Use</Link>
            <Link to="/dpa">Data Processing Agreement</Link>
          </div>

        </div>

      </div>

      <div className="footer-bottom">

        <span>
          ❤️ Proudly Zambian
        </span>
        <span>
          A Product of Revx Management Systems Limited
        </span>

        <span>
          © {year} Magyne ERP. All Rights Reserved.
        </span>

      </div>
    </footer>
  );
};

export default Footer;